module.exports = __webpack_public_path__ + "static/media/project_overview.c68bd221.jpeg";